import { getInkStyle, type InkColor } from '@/lib/ink-utils';

interface InkDotProps {
  ink: InkColor;
  size?: 'sm' | 'md';
}

export function InkDot({ ink, size = 'sm' }: InkDotProps) {
  const style = getInkStyle(ink);
  return (
    <span
      className={`inline-block rounded-full ${style.dot} ${
        size === 'sm' ? 'h-2.5 w-2.5' : 'h-3.5 w-3.5'
      }`}
    />
  );
}
